const textMap = {
  'Advice - NVEI': {
    fr: 'Obtenir mon prix',
    en: 'Get my price',
    es: 'Calcular precio',
  },
  'Advice - Investissement locatif': {
    fr: 'Obtenir mon prix',
    en: 'Get my price',
    es: 'Calcular precio',
  },
  'Advice - Prêt immobilier': {
    fr: 'Faire ma simulation',
    en: 'Make a simulation',
    es: 'Haz una simulación',
  },
  'Advice - Copropriété': {
    fr: 'Obtenir mon prix',
    en: 'Get my price',
    es: 'Calcular precio',
  },
}

const tagMap = {
  'Advice - NVEI': (lang) => ({
    url: `https://www.luko.eu/${lang}/onboard/escooter`,
    text: textMap['Advice - NVEI'][lang],
  }),
  'Advice - Investissement locatif': (lang) => ({
    url: `https://www.luko.eu/${lang}/onboard`,
    text: textMap['Advice - Investissement locatif'][lang],
  }),
  'Advice - Prêt immobilier': (lang) => ({
    url: `https://mgi.luko.eu/`,
    text: textMap['Advice - Prêt immobilier'][lang],
  }),
  'Advice - Copropriété': (lang) => ({
    url: `https://mri.luko.eu/`,
    text: textMap['Advice - Copropriété'][lang],
  }),
}

const productMap = {
  appartement: {
    url: `https://www.luko.eu/fr/onboard?$.home.main_asset.type=flat`,
  },
  maison: {
    url: `https://www.luko.eu/fr/onboard?$.home.main_asset.type=house`,
  },
  flat: {
    url: `https://www.luko.eu/en/onboard?$.home.main_asset.type=flat`,
  },
  house: {
    url: `https://www.luko.eu/en/onboard?$.home.main_asset.type=house`,
  },
  'trottinette-electrique-nvei': {
    url: `https://www.luko.eu/fr/onboard/escooter`,
  },
  'electric-scooter': {
    url: `https://www.luko.eu/en/onboard/escooter`,
  },
  tierkrankenversicherung: {
    url: `https://www.luko.eu/de/onboard/pets`,
  },
  hundehaftpflicht: {
    url: `https://www.luko.eu/de/onboard/pets`,
  },
  'pet-health': {
    url: `https://www.luko.eu/en/onboard/pets`,
  },
  'dog-liability': {
    url: `https://www.luko.eu/en/onboard/pets`,
  },
}

export const getNavCtaLinkByTagName = (tags, lang) => {
  const tag = tags.find((tag) => tagMap[tag])
  if (tag) return tagMap[tag](lang)
  return {}
}

export const getNavCtaLinkByProductUid = (uid) => {
  return productMap[uid] || {}
}
